export const APPLICATION_INTERACTION_STATUS_VALUES = [
  'SUCCEEDED',
  'FAILED',
  'BLOCKED',
  'PARTIAL',
  'UNKNOWN',
] as const;

export type ApplicationInteractionStatusValue =
  (typeof APPLICATION_INTERACTION_STATUS_VALUES)[number];

export const resolveInteractionStatusFromHttpResponse = (
  httpStatusCode: number | undefined,
): ApplicationInteractionStatusValue => {
  if (httpStatusCode == null) {
    return 'UNKNOWN';
  }

  if (httpStatusCode >= 500) {
    return 'FAILED';
  }

  if (httpStatusCode === 403 || httpStatusCode === 429) {
    return 'BLOCKED';
  }

  if (httpStatusCode >= 400) {
    return 'FAILED';
  }

  return 'SUCCEEDED';
};

export const normalizeApplicationInteractionStatus = ({
  status,
  outcome,
  statusCode,
}: {
  status?: unknown;
  outcome?: unknown;
  statusCode?: number;
}): ApplicationInteractionStatusValue => {
  if (
    typeof status === 'string' &&
    APPLICATION_INTERACTION_STATUS_VALUES.includes(
      status as ApplicationInteractionStatusValue,
    )
  ) {
    return status as ApplicationInteractionStatusValue;
  }

  if (
    typeof outcome === 'string' &&
    APPLICATION_INTERACTION_STATUS_VALUES.includes(
      outcome as ApplicationInteractionStatusValue,
    )
  ) {
    return outcome as ApplicationInteractionStatusValue;
  }

  if (typeof status === 'number') {
    return resolveInteractionStatusFromHttpResponse(status);
  }

  if (statusCode != null) {
    return resolveInteractionStatusFromHttpResponse(statusCode);
  }

  return 'UNKNOWN';
};
